import * as types from '../actions/types';

const initialState = {
  educationPrograms: [],
  disciplineRPD:[],
  discipline: [],
  isLoading: false,
  isError: false,
  pagesCount:0,
  totalCount: 0,
};

export default function educationWorkPrograms(state = initialState, action) {
  switch (action.type) {
    case types.GET_EDUCATION_WORK_PROGRAMS_REQUEST_STARTED:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case types.GET_EDUCATION_WORK_PROGRAMS_REQUEST_COMPLETED:
    return {
        ...state,
        educationPrograms: action.data,
        isLoading: false,
        isError: false,
      };
    case types.GET_EDUCATION_WORK_PROGRAMS_REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case types.SET_EDUCATION_WORK_PROGRAMS_COUNT:
      return {
        ...state,
        pagesCount: action.data,
        totalCount: action.total || 0,
        };

    case types.GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_COMPLETED:
       return {
        ...state,
        disciplineRPD: action.data,
        };
  
    case types.GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_COMPLETED:
       return {
        ...state,
        discipline: action.data.meta_course,
        };

    default:
      return state;
  }
}
